import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { unauthenticatedGuard } from 'src/app/core/guards/authenticated/unauthenticated.guard';
import { AuthDashboardComponent } from './components/auth-dashboard/auth-dashboard.component';
import { LoggedOutComponent } from './components/logged-out/logged-out.component';
import { LoginComponent } from './components/login/login.component';
import { unifiedAuthGuard } from './guards/unified-auth.guard';

const routes: Routes = [
  {
    path: 'logged-out',
    component: LoggedOutComponent,
    canActivate: [unauthenticatedGuard],
  },
  {
    path: '',
    component: AuthDashboardComponent,
    canActivate: [unauthenticatedGuard, unifiedAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        title: 'Login',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
